/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useDynamicFieldPosition } from "cms/fields/dynamic-field";
import { useRef } from "react";
import { useUpdateEffect } from "react-use";
import { Logger, cyan } from "cms/utils/log/logger";

/**
 * Retrive a reference to the latest field position.  The field is provided by
 * the dynamic field context.
 * 
 * Whenever this field's position changes, it will be updated here as well.
 * 
 * @see useDynamicFieldPosition
 */
const useLatestFieldPosition = () => {
    const fieldPosition = useDynamicFieldPosition();

    /**
     * Record the latest field position
     */
    const latestFieldPosition = useRef(fieldPosition);

    useUpdateEffect(
        () => {
            Logger.debug(cyan(`[update-component] field position has changed to ${fieldPosition}, updating`));
            latestFieldPosition.current = fieldPosition;
        },
        [fieldPosition]
    );

    return latestFieldPosition;
};

export { useLatestFieldPosition };
